<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar class="mb-2" color="primary" dark flat>
          <v-toolbar-title>Export údajov z DB</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" class="pt-0">
        <v-card max-width="1000">
          <v-list>
            <v-list-item v-for="mer in merania" :key="mer">
              <v-list-item-content>
                <v-list-item-title
                  v-text="getDescription(mer)"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon
                v-for="typ in typyExportu"
                :key="typ.name + '_' + mer"
              >
                <v-btn
                  @click="clickDownload(mer, typ.name)"
                  :loading="loading"
                  :disabled="loading"
                >
                  <v-icon dark>{{ typ.icon }}</v-icon>
                  {{ typ.text }}
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card>

        <h2 class="ma-5">Export doplňujúcich údajov k bodom</h2>

        <v-card max-width="1000">
          <v-list>
            <v-list-item v-for="mer in mb" :key="mer">
              <v-list-item-content>
                <v-list-item-title
                  v-text="getDescription(mer)"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon
                v-for="typ in typyExportu"
                :key="typ.name + '_' + mb"
              >
                <v-btn
                  @click="clickDownload(mer, typ.name)"
                  :loading="loading"
                  :disabled="loading"
                >
                  <v-icon dark>{{ typ.icon }}</v-icon>
                  {{ typ.text }}
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="2" class="pt-0">
        <v-text-field
          label="Exportovať za rok"
          hint="Vyplniť rok za ktorý chcete exportovať údaje, napr. 2020"
          v-model="exportRok"
          maxlength="4"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as Enums from "../plugins/enums.js"

export default {
  data: function() {
    return {
      loading: false,
      exportRok: "",
      typyExportu: [
        {
          name: "xls",
          text: "Export vo formáte Excel",
          icon: "mdi-file-excel-box-outline"
        },
        {
          name: "csv",
          text: "Export vo formáte CSV",
          icon: "mdi-comma-box-outline"
        }
      ],
      merania: [
        Enums.TYPY.DILAT,
        Enums.TYPY.GEO,
        Enums.TYPY.HPV,
        Enums.TYPY.INKP,
        Enums.TYPY.INKS,
        Enums.TYPY.MIKRO,
        Enums.TYPY.PEEP,
        Enums.TYPY.PEES,
        Enums.TYPY.POTRUB,
        Enums.TYPY.PRNA,
        Enums.TYPY.PT,
        Enums.TYPY.HPVQ,
        Enums.TYPY.STAB
      ],
      mb: [
        Enums.TYPY.MBPotrub,
        Enums.TYPY.MBPT,
        Enums.TYPY.MBHPV,
        Enums.TYPY.MBDilat,
        Enums.TYPY.MBStab,
        Enums.TYPY.MBMikro,
        Enums.TYPY.MBINK
      ]
    }
  },
  components: {},
  methods: {
    getExportUrl: function(mer, typ) {
      let expRok = "all"
      if (this.exportRok !== null) {
        if (this.exportRok !== "") {
          expRok = this.exportRok
        }
      }
      return `export/${mer}/${typ}/${expRok}`
    },
    getTableName: function(mer) {
      return Enums.getTableName(mer)
    },
    getDescription: function(mer) {
      return Enums.getDescription(mer)
    },
    clickDownload: async function(mer, typ) {
      console.log(mer, typ)
      if (this.exportRok === null || this.exportRok === "") {
        this.$store.commit("alert", "Nie je zadaný rok pre export")
        return
      }
      this.loading = true
      let url = this.getExportUrl(this.getTableName(mer), typ)
      this.$axios({
        url: url,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          let ret = ""
          try {
            ret = response.headers["content-disposition"]
            let n = ret.indexOf("filename=")
            ret = ret.substring(n + 10, ret.length - 1)
          } catch (error) {
            ret = "export." + typ
          }
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", ret)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => this.$store.commit("alert", error))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
